import React, { Component } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom'

import Document from './document.js';
import DocumentEdit from './documentEdit.js';

class DocumentDataLoader extends Component {

  constructor() {
    super();
    this.state = {
      redirect: ""
    }
    this.onDelete = this.onDelete.bind(this);
    this.onSave = this.onSave.bind(this);
  }

  onDelete() {
    this.setState({
      redirect: "/dashboard"
    })
  }

  onSave(id) {
    this.setState({
      redirect: ""
    })
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />;
    }
    let item = this.props.documents.find( doc => doc.id === this.props.match.params.id );
    return (
      <div>
        {item ?
        <Switch>
          <Route
            path='/document/:id/edit'
            render={(props) => <DocumentEdit {...props} user={this.props.user} item={item} onSave={this.onSave} onDelete={this.onDelete}/>}
          />
          <Route
            path='/document/:id'
            render={(props) => <Document {...props} user={this.props.user} item={item}/>}
          />
        </Switch>
        : <div className="spinner">
            <div className="rect1"></div>
            <div className="rect2"></div>
            <div className="rect3"></div>
            <div className="rect4"></div>
            <div className="rect5"></div>
          </div>}
      </div>
    );
  }
}

export default DocumentDataLoader;



// WEBPACK FOOTER //
// ./src/containers/documentDataLoader.js